import React, { useState, useRef } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { fetchInitialData, hasRecentInteractions } from '@fiverr-private/send_message';
import { object, node } from 'prop-types';
import { isNil } from 'lodash';
import {
    reportSendMessageSubmitSuccess,
    redirectToInboxConversation
} from '../../../utils/contactSeller';

export const FirstMessagePopup = (props, context) => {
    const firstMessagePackageRef = useRef();

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState();

    const onClick = async() => {
        try {
            const [, data] = await Promise.all([lazyLoadModal(), fetchModalData()]);

            if (checkRecentInteractions(data)) {
                redirect();
                return;
            }

            openModal();
        } catch (error) {
            reportModalInitializationError(error);
            redirect();
        }
    };

    const lazyLoadModal = async() => {
        try {
            firstMessagePackageRef.current = await import(/* webpackChunkName: 'SendMessagePopup' */'@fiverr-private/send_message');
        } catch (error) {
            reportLazyLoadError(error);
            throw error;
        }
    };

    const reportLazyLoadError = (error) => {
        context.logger.error(error, { description: 'Failed to lazy load @fiverr-private/send_message package.' });
    };

    const reportModalInitializationError = (error) => {
        context.logger.error(error, { description: 'Failed to initialize the First Message Popup' });
    };

    const checkRecentInteractions = (data) => {
        const sellerUsername = getSellerUsername();
        const { sender } = data;

        return hasRecentInteractions(sender.username, sellerUsername);
    };

    const redirect = () => {
        const { pathfinderWrapper } = context;
        redirectToInboxConversation(pathfinderWrapper);
    };

    const getSellerUsername = () => {
        const { pathParameters } = getContext();
        const { username: sellerUsername } = pathParameters;

        return sellerUsername;
    };

    const fetchModalData = async() => {
        if (!isNil(modalData)) {
            return modalData;
        }

        const sellerUsername = getSellerUsername();
        const data = await fetchInitialData(sellerUsername);

        setModalData(data);

        return data;
    };

    const openModal = () => {
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleSubmitSuccess = () => {
        const { biEvents } = context;
        reportSendMessageSubmitSuccess(biEvents);
    };

    const renderTrigger = () => {
        const trigger = props.trigger;

        return trigger({ open: onClick });
    };

    const getRelatedGigId = () => {
        const { general } = context;
        const { gigId } = general;

        return gigId;
    };

    const modalHasBeenLoaded = !isNil(firstMessagePackageRef.current);
    const Modal = modalHasBeenLoaded ? firstMessagePackageRef.current.ControlledSendMessageModal : EmptyComponent;
    const show = showModal && !isNil(modalData);

    return (
        <>
            { renderTrigger()}
            <Modal show={show}
                onClose={handleModalClose}
                relatedGigId={getRelatedGigId()}
                onSubmitSuccess={handleSubmitSuccess}
                recipientInfo={modalData?.recipient}
                showInfo={true}/>
        </>
    );
};

const EmptyComponent = () => null;

FirstMessagePopup.propTypes = {
    trigger: node
};

FirstMessagePopup.contextTypes = {
    pathfinderWrapper: object,
    general: object,
    logger: object,
    biEvents: object
};
